export var themeNamespace = '@atlaskit-shared-theme/button';
//# sourceMappingURL=theme.js.map